import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Button from '../Button/Button';
import {
  IconArrowRight, IconLoading, IconReload, IconUpload
} from '../../assets/icon';
import ButtonTypes from '../../constants/buttonTypes';
import CustomDropdownMenu from '../CustomDropdownMenu/CustomDropdownMenu';
import Text from '../Text/Text';
import getUploadsList from '../../thunks/users/getUploadsList';
import UploadMenuItem from './components/UploadMenuItem';

const UploadMenu = () => {
  const [menuVisible, setMenuVisible] = useState(false);
  const dispatch = useDispatch();
  const {
    getUploadsListData: {
      data, next, currentPage, loading
    }
  } = useSelector((state) => ({
    getUploadsListData: state?.getUploadsList,
  }), shallowEqual);

  useEffect(() => {
    if (menuVisible && !data.length) {
      dispatch(getUploadsList());
    }
  }, [menuVisible]);

  const refresh = () => dispatch(getUploadsList({
    page: 1,
    refresh: true
  }));

  return (
    <CustomDropdownMenu
      show={menuVisible}
      drop="down"
      onToggle={() => setMenuVisible(!menuVisible)}
      headerComponent={(
        <Button
          icon={<IconUpload color="#009EF7" />}
          type={ButtonTypes.WHITE}
          containerStyle="p-[7px]"
        />
      )}
      mainContainerStyle="p-0 rounded-[6px] w-full"
    >
      <div
        className="flex items-center rounded-tl-[6px] rounded-tr-[6px] bg-no-repeat bg-cover bg-[center_bottom]
        h-[60px] px-[30px] py-[10px]"
        style={{ backgroundImage: "url('/assets/images/menu-header-bg.jpg')" }}
      >
        <div className="flex flex-row flex-1 justify-between items-center">
          <Text text="Upload center" textStyle="text-[16px] text-white" />
          <div
            className="cursor-pointer hover:text-primary"
            role="presentation"
            onClick={refresh}
          >
            <IconReload color="#fff" />
          </div>
        </div>
      </div>
      <div className="customScroll max-h-[300px] overflow-auto py-[26px] mx-[16px]">
        {!!data?.length && data?.map((item) => <UploadMenuItem key={item.id} item={item} />)}

        {loading && (
          <div className="flex justify-center">
            <IconLoading widht={100} height={50} className="spin" />
          </div>
        )}

        {!loading && !data.length && (
          <div className="flex justify-center">
            <Text text="List empty" muted />
          </div>
        )}
      </div>
      <div className="min-h-[20px]">
        {next && (
          <Button
            text="Load more"
            iconRight={<IconArrowRight />}
            type={ButtonTypes.WHITE}
            onClick={() => dispatch(getUploadsList({ page: currentPage + 1 }))}
          />
        )}
      </div>
    </CustomDropdownMenu>
  );
};

UploadMenu.propTypes = {};

UploadMenu.defaultProps = {};

export default UploadMenu;
